import { z } from "zod";

export const GetMeResponseSchema = z.object({
	id: z.string().cuid(),
	email: z.string().email(),
	name: z.string().nullable().optional(),
	provider: z.enum(["EMAIL", "GOOGLE", "NAVER", "KAKAO"]),
	plan: z.enum(["FREE", "BASIC", "PRO", "ENTERPRISE"]),
	gyulBalance: z.number().int(),
	createdAt: z.string().datetime(),
});

export const UpdateMeRequestSchema = z.object({
	email: z.string().email().optional(),
	name: z.string().optional(),
});

export const UpdateMeResponseSchema = z.object({
	id: z.string().cuid(),
	email: z.string().email(),
	name: z.string().nullable().optional(),
	provider: z.enum(["EMAIL", "GOOGLE", "NAVER", "KAKAO"]),
	plan: z.enum(["FREE", "BASIC", "PRO", "ENTERPRISE"]),
	gyulBalance: z.number().int(),
});

export const GetGyulDebtResponseSchema = z.object({
	debts: z.array(
		z.object({
			id: z.string().cuid(),
			createdAt: z.string().datetime(),
			userId: z.string().cuid(),
			amount: z.number().int(),
			reason: z.string(),
			resolved: z.boolean(),
		}),
	),
});

export type GetMeResponse = z.infer<typeof GetMeResponseSchema>;
export type UpdateMeRequest = z.infer<typeof UpdateMeRequestSchema>;
export type UpdateMeResponse = z.infer<typeof UpdateMeResponseSchema>;
export type GetGyulDebtResponse = z.infer<typeof GetGyulDebtResponseSchema>;
